angular.module('tf.directives')



    .directive('pbac', ['Session', function(Session){
        return {
            restrict : 'A',
            link : function(scope, element, attrs){
                var pbac = attrs.pbac ;
                var invert = false;
                if(pbac.startsWith('!')){
                    invert = true;
                    pbac = pbac.substr(1);
                }
                element.removeAttr('pbac');
                var plan = (Session && Session.farm && Session.farm.plan.code) || 0;

                try{
                    if(invert? plan >= parseInt(pbac) : plan < parseInt(pbac)){
                        element.remove();
                    }
                } catch(e){
                    element.remove();
                }

            }
        };
    }])

;

